<template>
    <v-chip :color="statusColor(status)" theme="dark">
        {{ status || "New" }}
    </v-chip>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        status: {
            type: String,
            required: false,
        },
    },

    computed: {
        statusColor() {
            return (status) => {
                switch (status) {
                    case "New":
                        return "blue";
                    case "No Data":
                        return "grey";
                    case "Confirm QC":
                    case "Confirm QC with Error":
                        return "green";
                    case "Data Overdue":
                        return "#FFD700"; // gold
                    case "Contact CRO":
                        return "orange";
                    case "Missing Data":
                    case "Not Collected":
                        return "red";
                    case "Looker Flag":
                        return "purple";
                    case "Canceled":
                        return "darkgrey";
                    default:
                        return "grey";
                }
            };
        },
    },
});
</script>
